import { render, staticRenderFns } from "./DeleteProviderAcuInfo.vue?vue&type=template&id=0827b23c"
import script from "./DeleteProviderAcuInfo.vue?vue&type=script&lang=js"
export * from "./DeleteProviderAcuInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports